export default __webpack_public_path__ + "static/media/incrementality_monitoring_icon.d984be48.svg";